var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIdbSecundair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_x27_s",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 972.75 196.7",
    style: {
      enableBackground: "new 0 0 972.75 196.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:none;stroke:#F4BB21;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#D2D3D5;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#57585A;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{clip-path:url(#SVGID_4_);}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#FFFFFF;stroke:#585858;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{clip-path:url(#SVGID_6_);}\n\t.st8{fill:#BBBBBB;}\n\t.st9{fill:#D3D3D3;}\n\t.st10{fill:none;stroke:#585858;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#585858;}\n\t.st12{clip-path:url(#SVGID_8_);}\n\t.st13{fill:#F4BB21;}\n\t.st14{fill:#D2D3D5;}\n\t.st15{fill:#57585A;}\n\t.st16{clip-path:url(#SVGID_10_);}\n\t.st17{clip-path:url(#SVGID_12_);}\n\t.st18{fill:none;stroke:#F4BB21;stroke-width:5;stroke-miterlimit:10;}\n\t.st19{fill:none;stroke:#C7C8CA;stroke-width:5;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#57585A;stroke-width:5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M76.2,28.67c20.65,0,29.63,13.57,29.63,33.26v67.29c0,19.69-8.98,33.26-29.63,33.26H46.76V28.67H76.2z  M76.01,154.45c14.91,0,21.03-10.13,21.03-24.85V61.55c0-14.72-6.31-24.85-21.03-24.85H55.55v117.76H76.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M165.66,90.61v8.03h-36.51v55.82h43.97v8.03h-52.76V28.67h52.76v8.03h-43.97v53.91H165.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M195.48,162.48h-8.03V28.67h11.47l40.14,112.98V28.67h8.03v133.81h-9.75L195.48,43.2V162.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M284.75,162.48V36.7H257.6v-8.03h63.27v8.03h-27.34v125.78H284.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M340.56,28.67v133.81h-8.79V28.67H340.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M378.41,162.48V36.7h-27.14v-8.03h63.27v8.03H387.2v125.78H378.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M452.96,111.06l-30.01-82.39h9.18l25.62,70.35l25.62-70.35h8.6l-30.2,82.39v51.42h-8.79V111.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M532.86,28.67c20.07,0,27.34,9.94,27.34,28.48v7.65c0,14.53-4.01,23.51-17.59,26.38 c14.53,2.87,20.07,13.57,20.07,28.67v11.66c0,19.31-8.79,30.97-29.25,30.97h-28.67V28.67H532.86z M528.46,87.74 c15.67,0,22.94-4.21,22.94-21.22v-8.6c0-13.96-4.4-21.22-18.73-21.22h-19.12v51.04H528.46z M533.43,154.45 c14.72,0,20.46-8.22,20.46-23.13v-12.04c0-17.4-7.84-23.51-23.7-23.51h-16.63v58.69H533.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M585.43,130.18c0,14.34,5.35,25.42,20.07,25.42c14.72,0,20.07-11.09,20.07-25.42V28.67h8.22v101.13 c0,19.12-8.03,33.83-28.48,33.83s-28.67-14.72-28.67-33.83V28.67h8.79V130.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M657.68,28.67v133.81h-8.79V28.67H657.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M672.97,162.48V28.67h8.79v125.78h42.06v8.03H672.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M766.45,28.67c20.64,0,29.63,13.57,29.63,33.26v67.29c0,19.69-8.99,33.26-29.63,33.26h-29.44V28.67H766.45z  M766.26,154.45c14.91,0,21.03-10.13,21.03-24.85V61.55c0-14.72-6.31-24.85-21.03-24.85H745.8v117.76H766.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M819.4,28.67v133.81h-8.79V28.67H819.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M842.72,162.48h-8.03V28.67h11.47l40.14,112.98V28.67h8.03v133.81h-9.75L842.72,43.2V162.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M966.58,61.36v9.94h-8.41V60.78c0-14.34-5.54-25.23-20.26-25.23c-14.72,0-20.26,10.9-20.26,25.23v69.58 c0,14.34,5.54,25.04,20.26,25.04c14.72,0,20.26-10.71,20.26-25.04V101.5H940.4v-8.03h26.19v36.32c0,19.31-8.41,33.83-28.87,33.83 s-28.87-14.53-28.87-33.83V61.36c0-19.31,8.41-33.84,28.87-33.84S966.58,42.05,966.58,61.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M16,173.13c-1.38,0-2.5-1.12-2.5-2.5V80.81c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v89.82 C18.5,172.01,17.38,173.13,16,173.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M16,59.2c-8.33,0-15.1-6.77-15.1-15.1C0.9,35.77,7.67,29,16,29s15.1,6.77,15.1,15.1 C31.1,52.43,24.33,59.2,16,59.2z M16,34c-5.57,0-10.1,4.53-10.1,10.1c0,5.57,4.53,10.1,10.1,10.1s10.1-4.53,10.1-10.1 C26.1,38.53,21.57,34,16,34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M28.6,162.15c-1.38,0-2.5-1.12-2.5-2.5V80.53c0-5.57-4.53-10.1-10.1-10.1S5.9,74.96,5.9,80.53v79.12 c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5V80.53c0-8.33,6.77-15.1,15.1-15.1s15.1,6.77,15.1,15.1v79.12 C31.1,161.03,29.98,162.15,28.6,162.15z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIdbSecundair);
export default __webpack_public_path__ + "static/media/logo_idb_secundair.4070780ae194eb6e515f2d15b48af7fa.svg";
export { ForwardRef as ReactComponent };